import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
// import { BASE_URL, IMG_URL } from "../../apiHelper/authService";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";
import { BASE_URL, deleteSliderImageApi, getSliderImagesApi, IMG_URL } from "../../helper/api_helper";

function SampleNextArrow() { return null }
function SamplePrevArrow() { return null }


const SliderManagement = () => {
    // const settings = {
    //   dots: false,
    //   arrows: true,
    //   infinite: true,
    //   speed: 1000,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   initialSlide: 0,
    //   nextArrow: <SampleNextArrow />,
    //   prevArrow: <SamplePrevArrow />,
    // };
    const [clientImages, setClientImages] = useState([]);
    const [sliderImage, setSliderImage] = useState(null)
    const [secondSliderImage, setSecondSliderImage] = useState(null)
    const [gridImage, setGridImage] = useState(null)
    const [loadingLogo, setLoadingLogo] = useState(false)






    const handleFileChange = (e, type) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            src: URL.createObjectURL(file),
            file,
        }));


        setClientImages((prev) => [...prev, ...newImages]);


        e.target.value = "";
    };
    const removeImage = (src, type) => {

        setClientImages((prev) => prev.filter((img) => img.src !== src));

        URL.revokeObjectURL(src);
    };




    const [isClientAddOpen, setIsClientAddOpen] = useState(false);
    const [isSliderAddOpen, setIsSliderAddOpen] = useState(false);
    const [isSecondSliderAddOpen, setIsSecondSliderAddOpen] = useState(false);
    const [isGridAddOpen, setIsGridAddOpen] = useState(false);




    const [firstSlider, setFirstSlider] = useState([]);

    const [secondSlider, setSecondSlider] = useState([])

    // Carousel removed — images will be shown in normal list/grid format



    const [clientLogos, setClientLogos] = useState()
    const [homepageImages, setHomePageImages] = useState();
    const [isNewImageCreateOpen, setIsNewImageCreateOpen] = useState(true)

    const [indexNo, setIndexNo] = useState(0)

    const firstSliderGet = async () => {
        try {
            let response = await getSliderImagesApi();
            // if (response.status === 200) {
            setFirstSlider(response.data);

            // }
        } catch (error) {

        }
    };








    useEffect(() => {
        firstSliderGet();
        // getImages();
        // secondSliderGet()
        // getClientLogos();
    }, []);
  
    const handleNewImageAddClick = () => {
        setIsNewImageCreateOpen(!isNewImageCreateOpen)
    }






    const handleSliderDelete = async (sliderId) => {
        try {
            const response = await deleteSliderImageApi({ id: sliderId });

            // Check if message is nested or not
            toast.success(response?.message || "Image deleted successfully");

            firstSliderGet();
        } catch (error) {
            toast.error(error || "Something went wrong");
   
        }
    };










    const handleImageChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        const newImage = {
            src: URL.createObjectURL(file),
            file,
        };

        if (type === "slider_img") {
            setSliderImage(newImage); // only one
        } else if (type === "second_slider_img") {
            setSecondSliderImage(newImage); // only one

        }

        else if (type === "grid_img") {

            setGridImage(newImage); // only one

        }

        e.target.value = "";
    };


    const removeImageChange = (src, type) => {
        URL.revokeObjectURL(src);

        if (type === "slider_img") {
            setSliderImage(null);
        } else if (type === "second_slider_img") {
            setSliderImage(null);

        }

        else if (type === "grid_img") {
            setGridImage(null)
        }
    };

    const handleSliderUpload = async () => {
        if (!sliderImage) {
            toast.error("Please upload a slider image first.");
            return;
        }

        const formData = new FormData();
        formData.append("image_url", sliderImage.file);
        formData.append("index", indexNo);


        const toastId = toast.loading("Uploading slider image...");



        try {
            const response = await axios.post(`${BASE_URL}/add-slider-image/admin`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            // if (response.status === 200) {
            toast.success(response.data.message || "Slider image uploaded successfully!", { id: toastId });

            setSliderImage(null);
            setIsSliderAddOpen(false);
            firstSliderGet()
            // }
        } catch (error) {



            if (error?.code === "ERR_NETWORK") {
                toast.error("Image size is too large. Please upload a smaller file.", { id: toastId });
            } else {
                toast.error(error?.response?.data?.message || "Something went wrong.", { id: toastId });
            }

        }

    };








    return (
        <MasterLayout>
            <Breadcrumb title="Slider Images Management" />


            <div className="row gy-4">







                <div className="card h-100 radius-12 overflow-hidden arrow-carousel" style={{ padding: "10px" }}>


                    <div className="d-flex justify-content-between align-items-center" style={{ padding: "10px 0px" }}>
                        <h6 htmlFor="" className="text-muted" > Slider Images</h6>
                        <button
                            type="button"
                            onClick={() => setIsSliderAddOpen(!isSliderAddOpen)}
                            className="btn btn-primary-600 radius-8 px-20 py-11"
                        >
                            + Add Slider Image
                        </button>
                    </div>

                    {firstSlider?.length === 0 ? (
                        <div className="text-center p-4">No slider image found</div>
                    ) : (
                        <div className="row g-3">
                            {firstSlider?.map((item, index) => (
                                <div key={item?.id ?? index} className="col-12 col-sm-6 col-md-4">
                                    <div
                                        className="position-relative"
                                        style={{
                                            width: "100%",
                                            height: "300px", // Fixed image height
                                            borderRadius: "0px",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {/* Image */}
                                        <img
                                            src={`${IMG_URL}/${item?.image_url}`}
                                            alt={`slider-${index}`}
                                            className="w-100 h-100 object-fit-contain"
                                            style={{ borderRadius: "0px" }}
                                        />

                                        <button
                                            type="button"
                                            className="fw-medium rounded-circle w-40-px h-40-px d-flex justify-content-center align-items-center border-0"
                                            title="Delete"
                                            style={{
                                                backgroundColor: "#E6EBF9",
                                                color: "#243E85",
                                                border: "1px solid #243E85",
                                                position: "absolute",
                                                top: "7px",
                                                right: "7px",
                                                zIndex: 2,
                                            }}
                                            onClick={() => handleSliderDelete(item?.id)}
                                        >
                                            <Icon icon="mdi:trash-can-outline" className="icon text-lg" />
                                        </button>
                                    </div>

                                    {/* Index Display (below image) */}
                                    <div
                                        className="mt-2 px-3 py-1 text-sm fw-semibold"
                                        style={{
                                            backgroundColor: "#243E85",
                                            color: "#fff",
                                            borderRadius: "4px",
                                            display: "inline-block",
                                        }}
                                    >
                                        Index: {item?.index ?? index}
                                    </div>
                                </div>
                            ))}
                        </div>

                    )}


                </div>











            </div>




            {isSliderAddOpen &&

                <div className="modal fade show" style={{ display: "block" }}>
                    <div
                        className="modal-dialog modal-lg modal-dialog-centered"
                        style={{ zIndex: 11122 }}
                    >
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                                <h1 className="modal-title fs-5">Add Slider Image</h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setIsSliderAddOpen(!isSliderAddOpen)}
                                />
                            </div>

                            <div className="modal-body p-24">
                                <form>
                                    <div className="row">



                                        <div className="card-body p-0">

                                            <div className="mb-4" style={{ width: "100%", maxWidth: "600px", margin: "0 auto" }}>
                                                <label class="form-label fw-semibold">Index No.</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control border rounded px-3 py-2 w-full"
                                                    placeholder="Enter index number"

                                                    value={indexNo}
                                                    onChange={(e) => setIndexNo(e.target.value)}
                                                // value={sliderImage?.index || ""}

                                                />
                                            </div>

                                            <div className="upload-image-wrapper d-flex flex-column gap-3 w-100" style={{ justifyContent: "center" }}>
                                                <div className="uploaded-imgs-container" style={{ justifyContent: "center", display: "flex" }}>
                                                    {sliderImage && (
                                                        <div className="position-relative border input-form-light radius-12 overflow-hidden border-dashed bg-neutral-50" style={{ width: "100%", maxWidth: "600px", height: "200px" }}>
                                                            <button
                                                                type="button"
                                                                className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 m-8 d-flex"
                                                                onClick={() => removeImageChange(sliderImage.src, "slider_img")}
                                                            >
                                                                <Icon icon="radix-icons:cross-2" className="text-xl text-danger-600" />
                                                            </button>
                                                            <img
                                                                className="w-100 h-100 object-fit-cover"
                                                                src={sliderImage.src}
                                                                alt="Slider Preview"
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                {!sliderImage && (
                                                    <label
                                                        className="upload-file-single border input-form-light radius-12 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center justify-content-center flex-column gap-2"
                                                        htmlFor="upload-slider"
                                                        style={{ width: "100%", maxWidth: "600px", height: "200px", margin: "auto" }}
                                                    >
                                                        <Icon icon="solar:camera-outline" className="text-2xl text-secondary-light" />
                                                        <span className="fw-semibold text-secondary-light">Upload Slider Image</span>
                                                        <input
                                                            id="upload-slider"
                                                            type="file"
                                                            hidden
                                                            onChange={(e) => handleImageChange(e, "slider_img")}
                                                        />
                                                    </label>
                                                )}
                                            </div>

                                        </div>

                                        <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                            <button
                                                type="button"
                                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                                onClick={() => setIsSliderAddOpen(!isSliderAddOpen)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                disabled={!sliderImage}
                                                onClick={handleSliderUpload}
                                                className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"

                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Optional backdrop */}
                    <div
                        className="modal-backdrop fade show"
                        //   onClick={handleCloseModal}
                        style={{ zIndex: 1040 }}
                    />
                </div>


            }







            <style>
                {`
          .slick-slide {
            display: flex !important;
            justify-content: center;
            align-items: center;
          }

          .slick-slide > div {
            width: 100%;
          }

          .slick-track {
            display: flex !important;
            flex-direction: row !important;
          }

                    .object-fit-cover {
                        object-fit: cover;
                    }

                    .object-fit-contain {
                        object-fit: contain;
                        background-color: #f8fafc;
                    }
        `}
            </style>
        </MasterLayout>
    );
};

export default SliderManagement;
